var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 690,
    height: 24,
    viewBox: "0 0 690 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M689.061 13.0607C689.646 12.4749 689.646 11.5252 689.061 10.9394L679.515 1.39346C678.929 0.80767 677.979 0.80767 677.393 1.39346C676.808 1.97924 676.808 2.92899 677.393 3.51478L685.879 12.0001L677.393 20.4853C676.808 21.0711 676.808 22.0209 677.393 22.6067C677.979 23.1924 678.929 23.1924 679.515 22.6067L689.061 13.0607ZM-1.2918e-07 13.5L688 13.5001L688 10.5001L1.2918e-07 10.5L-1.2918e-07 13.5Z",
    fill: "#3E809D",
    fillOpacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHorizontal);
export default __webpack_public_path__ + "static/media/arrow-horizontal.3e7058292a74fd70f6505d7a73947a9e.svg";
export { ForwardRef as ReactComponent };